import {
  AddEditContactFormValues,
  ContactFormPhoneItem,
  VALID_PHONE_TYPES,
  ContactFormGroupItem,
} from 'theSource/features/Contacts/components';
import { Contact } from 'theSource/features/Contacts/types';

export const mapContactToEditFormValues = (
  contact: Contact,
  existingGroups: string[]
): AddEditContactFormValues => ({
  name: contact.name,
  title: contact.title,
  email: contact.email,
  phones: mapPhoneNumbersToFormValues(contact),
  groups: mapGroupsToFormValues(contact, existingGroups),
  address: contact.address,
  website: contact.url,
  notes: contact.notes,
});

const mapPhoneNumbersToFormValues = (
  contact: Contact
): ContactFormPhoneItem[] => {
  const phones: ContactFormPhoneItem[] = [];

  if (contact.cellPhone) {
    phones.push({ phone: contact.cellPhone, type: VALID_PHONE_TYPES.MOBILE });
  }
  if (contact.homePhone) {
    phones.push({ phone: contact.homePhone, type: VALID_PHONE_TYPES.HOME });
  }
  if (contact.workPhone) {
    phones.push({ phone: contact.workPhone, type: VALID_PHONE_TYPES.WORK });
  }
  return phones;
};

const mapGroupsToFormValues = (
  contact: Contact,
  existingGroups: string[]
): ContactFormGroupItem[] =>
  existingGroups.map((group) => ({
    label: group,
    checked: contact.groups.includes(group),
  }));
